module.exports = __webpack_public_path__ + "img/icon-add-circle-outline.37b9f1a7.svg";